import ActionTypes from "./constants/action-types";
import axios from "axios";

export function updateMute(mute_val) {
    return {
        type: "UPDATE_MUTE",
        mute_val: mute_val,
    };
}

export function updateMuteOther(mute_other_val) {
    return {
        type: "UPDATE_MUTE_OTHER",
        mute_other_val: mute_other_val,
    };
}

export function setActiveUserR(activeUser) {
    return {
        type: "SET_ACTIVE_USER",
        activeUser: activeUser,
    };
}

export function updateConvListR(convList) {
    return {
        type: ActionTypes.SET_CONV_LIST,
        convList: convList,
    };
}

export function appendConvListR(convList) {
    // console.log('ACTIONS:APPEND_CONV_LIST');
    return {
        type: ActionTypes.APPEND_CONV_LIST,
        convList: convList,
    };
}

export function reorderConvListR(convList, convIndex, newMsg) {
    return {
        type: "REORDER_CONV_LIST",
        convList: convList,
        convIndex: convIndex,
        newMsg: newMsg,
    };
}

export function reorderReceiveConvListR(
    convList,
    convIndex,
    newMsg,
    newTime,
    message
) {
    return {
        type: "REORDER_RECEIVE_CONV_LIST",
        convList: convList,
        convIndex: convIndex,
        newMsg: newMsg,
        newTime: newTime,
        message,
    };
}

export function updateUnreadConvListR(convList, convIndex) {
    return {
        type: "UPDATE_UNREAD_CONV_LIST",
        convList: convList,
        convIndex: convIndex,
    };
}

export function setConvIndexR(convIndex) {
    return {
        type: "SET_CONV_INDEX",
        convIndex: convIndex,
    };
}

export function updateShowPriceR(showPrice) {
    return {
        type: "UPDATE_SHOW_PRICE",
        showPrice: showPrice,
    };
}

export function updateShowVerificationR(showVerification) {
    return {
        type: "UPDATE_SHOW_VERIFICATION",
        showVerification: showVerification,
    };
}

export function updateTriggerScrollBottomR(triggerScrollBottom) {
    return {
        type: "UPDATE_TRIGGER_SCROLL_BOTTOM",
        triggerScrollBottom: triggerScrollBottom,
    };
}

export function updateShowMsgLoaderR(showMsgLoader) {
    return {
        type: "UPDATE_SHOW_MSG_LOADER",
        showMsgLoader: showMsgLoader,
    };
}

export function updateshowVideoModalR(showVideoModal) {
    return {
        type: "UPDATE_SHOW_VIDEO_MODAL",
        showVideoModal: showVideoModal,
    };
}

export function updateShowImageModalR(showImageModal) {
    return {
        type: "UPDATE_SHOW_IMAGE_MODAL",
        showImageModal: showImageModal,
    };
}

export function updateImageModalSrcR(imageModalSrc) {
    return {
        type: "UPDATE_IMAGE_MODAL_SRC",
        imageModalSrc: imageModalSrc,
    };
}

export function updateBroadcastMsgR(broadcastMsg) {
    return {
        type: "UPDATE_BROADCAST_MESSAGE",
        broadcastMsg: broadcastMsg,
    };
}

export function updateShowBundleModalR(showBundleModal) {
    return {
        type: "UPDATE_SHOW_BUNDLE_MODAL",
        showBundleModal: showBundleModal,
    };
}

export function updateBundleModalSrcR(bundleModalSrc) {
    return {
        type: "UPDATE_BUNDLE_MODAL_SRC",
        bundleModalSrc: bundleModalSrc,
    };
}

export function updateBundleIndexR(bundleIndex) {
    return {
        type: "UPDATE_BUNDLE_INDEX",
        bundleIndex: bundleIndex,
    };
}

export function updateActiveConvR(activeConv) {
    return {
        type: "UPDATE_ACTIVE_CONV",
        activeConv: activeConv,
    };
}

export function updateMsgOptionOpenR(msgOptionOpen) {
    return {
        type: "UPDATE_MSG_OPTION_OPEN",
        msgOptionOpen: msgOptionOpen,
    };
}

export function updateMsgStatsR(msgStats) {
    return {
        type: "UPDATE_MSG_STATS",
        msgStats: msgStats,
    };
}

export const fetchPosts = (params) => async (dispatch) => {
    let payload = {
        user: params.user ?? null,
        page: params.currentPage ?? null,
        post_length: params.postLn ?? null,
        per_page: params.perPage ?? null,
        is_pu: params.isPu ?? null,
        status: params.status ?? null,
        post_id: params.postid ?? null,
        category_id: params.category_id ?? null,
        page_name: params.pageName ?? null, // pinned posts are excluded in homepage
        type: params.type ?? "posts",
        keyword: params.keyword ?? null,
        filter: params.filter ?? null,
    };

    if (params.post_ids && params.post_ids.length > 0) {
        payload.post_ids = params.post_ids;
    }

    dispatch({
        type: ActionTypes.SET_LOADING,
        payload: true,
    });

    let response, timeoutId;
    try {
        response = await axios.get("/api/posts", {
            params: payload,
            cancelToken: params.source.token,
        });

        if (!params.post_ids || params.post_ids.length == 0) {
            dispatch({
                type: ActionTypes.SET_HAS_MORE,
                payload: response.data.data.length > 0,
            });

            dispatch({
                type: ActionTypes.SET_POSTS,
                payload: response.data.data,
            });

            dispatch({
                type: ActionTypes.SET_POSTS_TOTAL_ALL,
                payload: response.data.total_all,
            });

            dispatch({
                type: ActionTypes.SET_POST_IS_RESET,
                payload: false,
            });

            dispatch({
                type: ActionTypes.SET_POST_MEDIAS,
                payload: response.data.data,
            });

            dispatch({
                type: ActionTypes.SET_INITIALIZED,
                payload: true,
            });
        } else {
            dispatch({
                type: ActionTypes.UPDATE_POST_BY_TYPE,
                payload: response.data.data,
            });
        }
    } catch (error) {
        console.error({ error });
        dispatch({
            type: ActionTypes.SET_LOADING,
            payload: false,
        });
        if (axios.isCancel(error)) {
            console.log("Request canceled: ", error.message);
        }
    } finally {
        if (params.source) {
            params.source.cancel();
        }

        dispatch({
            type: ActionTypes.SET_LOADING,
            payload: false,
        });
    }
};

export const resetPosts = (params) => (dispatch) => {
    dispatch({
        type: ActionTypes.RESET_POSTS,
        payload: [],
    });
};

export const appendPosts = (params) => async (dispatch) => {
    dispatch({
        type: ActionTypes.SET_LOADING,
        payload: true,
    });

    let response;
    try {
        response = await axios.get("/api/posts", {
            params: {
                user: params.user,
                page: params.currentPage,
                per_page: params.perPage,
                is_pu: params.isPu,
                status: params.status,
                post_id: params.postid,
                page_name: params.pageName,
                category_id: params.category_id,
                post_length: params.postLn,
                filter: params.filter,
                type: params.type ?? "post",
            },
            cancelToken: params.source.token,
        });

        dispatch({
            type: ActionTypes.SET_HAS_MORE,
            payload: response.data.data.length > 0,
        });

        dispatch({
            type: ActionTypes.APPEND_POSTS,
            payload: response.data.data,
        });

        dispatch({
            type: ActionTypes.SET_POSTS_TOTAL_ALL,
            payload: response.data.total_all,
        });

        dispatch({
            type: ActionTypes.SET_LOADING,
            payload: false,
        });
    } catch (error) {
        if (axios.isCancel(error)) {
            console.log("Request canceled: ", error.message);
        }
    } finally {
        if (params.source) {
            params.source.cancel();
        }

        dispatch({
            type: ActionTypes.SET_LOADING,
            payload: false,
        });
    }
};

export function updatePost(payload) {
    return {
        type: ActionTypes.UPDATE_POST,
        payload,
    };
}

export function deletePost(payload) {
    return {
        type: ActionTypes.DELETE_POST,
        payload,
    };
}

export function setDarkmode(payload) {
    return {
        type: "SET_DARKMODE",
        payload: payload,
    };
}

export function setContainerClass(payload) {
    return {
        type: "SET_CONTAINER_CLASS",
        payload: payload,
    };
}

export function setProcessingFollow(payload) {
    return {
        type: ActionTypes.SET_PROCESSING_FOLLOW,
        payload: payload,
    };
}

export function setStashModal(payload) {
    return {
        type: ActionTypes.SET_STASH_MODAL,
        payload,
    };
}

export function setOrderModal(payload) {
    return {
        type: ActionTypes.SET_ORDER_MODAL,
        payload,
    };
}

export function setActiveAlbum(payload) {
    return {
        type: ActionTypes.SET_ACTIVE_ALBUM,
        payload,
    };
}

export function setBroadcastModal(payload) {
    return {
        type: ActionTypes.SET_BROADCAST_MODAL,
        payload,
    };
}

export function setShowPostAlbum(payload) {
    return {
        type: ActionTypes.SET_SHOW_POST_ALBUM,
        payload,
    };
}

export const setAlert = (payload) => {
    return {
        type: ActionTypes.SET_SHOW_ALERT,
        payload,
    };
};

export const getCategories = (params) => async (dispatch) => {
    dispatch({
        type: ActionTypes.SET_CATEGORIES_IS_BUSY,
        payload: true,
    });

    try {
        const response = await axios.get(`/api/categories`, {
            params: {
                per_page: params.perPage || 15,
                skip: params.categoriesLn || 0,
                all: params.all || "",
                creator: params.creator,
            },
        });

        dispatch({
            type: ActionTypes.SET_CATEGORIES_HAS_MORE,
            payload: response.data.data.length >= params.perPage,
        });

        dispatch({
            type: ActionTypes.SET_CATEGORIES,
            payload: response.data.data,
        });

        dispatch({
            type: ActionTypes.SET_CATEGORIES_IS_BUSY,
            payload: false,
        });
    } catch (error) {
        console.error({ error });
        dispatch({
            type: ActionTypes.SET_CATEGORIES_IS_BUSY,
            payload: false,
        });
    }
};

export const setCategories = (payload) => {
    return {
        type: ActionTypes.SET_CATEGORIES,
        payload,
    };
};

export const resetCategories = () => {
    return {
        type: ActionTypes.RESET_CATEGORIES,
    };
};

export const setHasMore = (payload) => {
    return {
        type: ActionTypes.SET_HAS_MORE,
        payload,
    };
};

export const setSelectedPost = (payload) => {
    return {
        type: ActionTypes.SET_POSTS_ACTIVE,
        payload,
    };
};

export const setSelectedPostGallery = (payload) => {
    return {
        type: ActionTypes.SET_POST_GALLERY_ACTIVE,
        payload,
    };
};

export const setCategoriesMode = (payload) => {
    return {
        type: ActionTypes.SET_CATEGORIES_MODE,
        payload,
    };
};

export const setOldCategories = (payload) => {
    return {
        type: ActionTypes.SET_OLD_CATEGORY,
        payload,
    };
};

export const setSettings = (params) => async (dispatch) => {
    await axios
        .get(`/api/settings`, {
            params: {
                only: params.only,
            },
        })
        .then((response) => {
            dispatch({
                type: ActionTypes.SET_SETTINGS,
                payload: response.data,
            });
        })

        .catch((error) => {
            console.error({ error });
        });
};

export const fetchFeed = (params) => async (dispatch, getState) => {
    dispatch({
        type: ActionTypes.SET_LOADING,
        payload: true,
    });

    const response = await axios.get("/api/feeds", {
        params: params,
    });

    dispatch({
        type: ActionTypes.SET_HAS_MORE,
        payload: response.data.data.length > 0,
    });

    dispatch({
        type: ActionTypes.SET_FEED,
        payload: response.data.data,
    });

    dispatch({
        type: ActionTypes.SET_LOADING,
        payload: false,
    });
};

export const appendFeed = (params) => async (dispatch) => {
    dispatch({
        type: ActionTypes.SET_LOADING,
        payload: true,
    });

    const response = await axios.get("/api/feeds", {
        params: params,
    });

    dispatch({
        type: ActionTypes.SET_HAS_MORE,
        payload: response.data.data.length > 0,
    });

    dispatch({
        type: ActionTypes.APPEND_FEED,
        payload: response.data.data,
    });

    dispatch({
        type: ActionTypes.SET_LOADING,
        payload: false,
    });
};

export function setPostAction(payload) {
    return {
        type: ActionTypes.SET_ACTION,
        payload,
    };
}
export const updateCcVerification = (payload) => {
    return {
        type: ActionTypes.UPDATE_CC_VERIFICATION,
        payload,
    };
};

export const setUser = (params) => async (dispatch) => {
    const userId = localStorage.getItem("loggedin_user");
    if (userId) {
        dispatch({
            type: ActionTypes.USER_FETCHING,
            payload: true,
        });
        await axios
            .get(`/api/users/${userId}`)
            .then((response) => {
                dispatch({
                    type: ActionTypes.SET_USER,
                    payload: response.data,
                });
                localStorage.setItem("user", JSON.stringify(response.data));

                dispatch({
                    type: ActionTypes.USER_FETCHING,
                    payload: false,
                });
            })
            .catch((error) => {
                console.error({ error });
                dispatch({
                    type: ActionTypes.USER_FETCHING,
                    payload: false,
                });
            });
    }
};

export const setPostWasReset = (payload) => ({
    type: ActionTypes.SET_POST_IS_RESET,
    payload,
});

// export function setShowChatGallery(show) {
//     return {
//         type: ActionTypes.SET_SHOW_CHAT_GALLERY,
//         payload: show,
//     };
// }

export const setPostMedias = (payload) => ({
    type: ActionTypes.SET_POST_MEDIAS,
    payload,
});

export const setSidebarBusy = (payload) => ({
    type: ActionTypes.SET_SIDEBAR_BUSY,
    payload,
});

export const setMessages = (payload) => ({
    type: ActionTypes.SET_MESSAGES,
    payload,
});

export const addReadMessage = (payload) => ({
    type: ActionTypes.ADD_READ_MESSAGES,
    payload,
});

export const updateOnlineStatusFromConvList = (payload) => ({
    type: ActionTypes.UPDATE_CONV_LIST_ONLINE_STATUS,
    payload,
});

export const updateUserFilter = (payload) => ({
    type: ActionTypes.UPDATE_USER_FILTER,
    payload,
});

export const updateMessengerSearchFilter = (payload) => ({
    type: ActionTypes.UPDATE_MESSENGER_SEARCH_FILTER,
    payload,
});

export const updateBroadcastIndicator = (payload) => ({
    type: ActionTypes.UPDATE_BROADCAST_INDICATOR,
    payload,
});

export const setCreditCardForm = (payload) => ({
    type: ActionTypes.SET_CC_FORM,
    payload,
});

export const toggleCreditCardForm = (payload) => ({
    type: ActionTypes.TOGGLE_CC_FORM,
    payload,
});

export const setPostKeyword = (payload) => ({
    type: ActionTypes.SET_POST_KW,
    payload,
});

export const setUserByValue = (payload) => ({
    type: ActionTypes.SET_USER,
    payload,
});

export const setPostIsInitialized = (payload) => ({
    type: ActionTypes.SET_INITIALIZED,
    payload,
});

export const setPosts = (payload) => ({
    type: ActionTypes.SET_POSTS,
    payload,
});
